import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React, { useState } from "react";
import { routes } from "utilities/routing/generatedRoutes";

export const ProductGroupNewSection = () => {
  const [value, setValue] = useState({
    title: "",
  });

  return <EditSectionTemplate
    submit={() => window.CoreApi.ProductGroup.Create({
      title: value.title,
    })}
    redirectUrl={(itemId) => routes.productGroup_Detail(itemId).absolute}
    sections={[{
      key: "productGroup",
      type: "regular",
      title: RESX.ProductGroup.resxProductGroup,
      fields: [{
        key: "title",
        label: RESX.GeneralLabels.Title,
        renderEditNew: () => <RequiredTextInput
          validatorKey="title"
          maxLength={serverReference.constants.productGroup.maxTitleLength}
          value={value.title}
          onChange={(title) => { setValue({ ...value, title }); }}
        />
      }],
    }]}
  />
};